import { createSlice } from "@reduxjs/toolkit";

const defaultButton = {
    label: "Ok",
};

const alertSlice = createSlice({
    name: "alertBox",
    initialState: {
        title: "",
        message: "",
        open: false,
        buttons: [defaultButton],
    },
    reducers: {
        showAlert: (state, action) => {
            state.open = true;
            state.title = action.payload.title ?? "";
            state.message = action.payload.message ?? "";
            state.buttons = action.payload.buttons ?? [defaultButton];
        },
        dismissAlert: (state) => {
            state.open = false;
            state.title = "";
            state.message = "";
            state.buttons = [defaultButton];
        },
    },
});

export const { showAlert, dismissAlert } = alertSlice.actions;

export default alertSlice.reducer;
